import type { RangePickerProps } from 'antd/es/date-picker';

import StyledDatePicker from '@/components/DatePicker';
import PropertyValue from '@/components/Typography/PropertyValue';
import useUserRole from '@/hooks/domain/useUserRole';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';

export const DateField = (
  props: CommonFieldProps & {
    feedbackAlias: string;
    date: DateString;
  },
) => {
  const { feedbackAlias, date } = props;
  const { isEditor } = useUserRole();
  const { updateDate } = useFeedbackListStore();
  const { updateDetail } = useFeedbackDetailContext();
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return (
      current && current > getTimezoneDayjs().addVal(1, 'day').startOf('day')
    );
  };

  if (props.isStatic)
    return (
      <PropertyRowWrapper {...props}>
        <PropertyValue
          value={getTimezoneDayjs(props.date).format(DATE_FORMAT.readable)}
        />
      </PropertyRowWrapper>
    );

  return (
    <PropertyRowWrapper {...props}>
      <StyledDatePicker
        disabled={!isEditor}
        name="date"
        onChange={(dayjs, _) => {
          if (dayjs) {
            updateDate(feedbackAlias, dayjs.toJSON());
            updateDetail({
              date: dayjs.toJSON(),
            });
          }
        }}
        disabledDate={disabledDate}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode as HTMLDivElement;
        }}
        value={getTimezoneDayjs(date)}
        format={DATE_FORMAT.readable}
        style={{
          padding: 4,
        }}
      />
    </PropertyRowWrapper>
  );
};
